import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuidv4 } from 'uuid'

import { ReactComponent as CloseIcon } from '../../../../../assets/icons/close-grey.svg'
import Field from '../../../../../components/Form/Field'
import ButtonIcon from '../../../../../features/components/Buttons/ButtonIcon'
import ActionText from '../../../../../components/ActionText'

function MultipleOptionsField({
  listFieldName,
  fieldPlaceholder,
  fieldMaxLength,
  formik,
  itemPath,
  minListQuantity = 1,
  maxListQuantity = 5
}) {
  const { values, setFieldValue } = formik

  const fieldsList = values[listFieldName]

  const addAnotherFieldItemHandler = useCallback(() => {
    if (fieldsList.length < maxListQuantity) {
      setFieldValue(listFieldName, [...fieldsList, { text: '', id: uuidv4() }])
    }
  }, [setFieldValue, fieldsList, listFieldName, maxListQuantity])

  const removeFieldItem = useCallback(
    deleteIndex => {
      if (fieldsList.length > 1) {
        const filteredList = fieldsList.filter((item, index) => {
          return index !== deleteIndex
        })
        setFieldValue(listFieldName, filteredList)
      }
    },
    [setFieldValue, fieldsList, listFieldName]
  )

  const getName = useCallback(({ itemPath, listFieldName, index }) => {
    return !!itemPath ? `${itemPath}.${listFieldName}[${index}].text` : `${listFieldName}[${index}].text`
  }, [])

  return (
    <>
      {fieldsList?.map((item, index) => (
        <Field
          key={item.id}
          placeholder={`${fieldPlaceholder} ${index + 1}`}
          formik={formik}
          name={getName({ itemPath, listFieldName, index })}
          maxLength={fieldMaxLength ? fieldMaxLength : null}
          symbol={
            fieldsList?.length > minListQuantity ? (
              <ButtonIcon onClick={() => removeFieldItem(index)} Icon={CloseIcon} />
            ) : null
          }
          isTextarea
          enableReinitialize
        />
      ))}
      {fieldsList?.length < maxListQuantity && (
        <ActionText onClick={addAnotherFieldItemHandler}>Add another</ActionText>
      )}
    </>
  )
}

MultipleOptionsField.propTypes = {
  listFieldName: PropTypes.string,
  fieldPlaceholder: PropTypes.string,
  fieldMaxLength: PropTypes.number,
  formik: PropTypes.object,
  itemPath: PropTypes.string,
  // control how many fields could be created/deleted
  minListQuantity: PropTypes.number,
  maxListQuantity: PropTypes.number
}

export default MultipleOptionsField
